import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import MealDropdown from '~/glm/components/guest-list/cells/meal-dropdown';
import SelectDropdown from '~/glm/components/guest-list/header/select-dropdown';
import RsvpDropdown from '~/glm/components/guest-list/header/rsvp-filter-dropdown';
import CustomQuestion from '~/glm/models/gds/gds-custom-question-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import OverviewRsvpDropdownContents from '~/glm/components/guest-list/header/overview-rsvp-dropdown-contents.jsx';
import styles from './selected-guests-dropdown.scss';

@observer
class SelectedGuestsDropdowns extends Component {
  static propTypes = {
    mealQuestion: PropTypes.instanceOf(CustomQuestion).isRequired,
    handleClick: PropTypes.func,
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    events: PropTypes.instanceOf(EventCollection),
  };

  state = {
    rsvpMenuState: false,
    mealMenuState: false,
  };

  setMenuState = (type, bool) => {
    if (typeof bool === 'boolean') {
      this.setState({ [type]: bool });
    } else {
      this.setState(state => ({
        [type]: !state[type],
      }));
    }
  };

  getRsvpLabel = () => {
    const { gdsUiState } = this.props;
    const { rsvpBulkSelection } = gdsUiState;
    if (rsvpBulkSelection) {
      return rsvpBulkSelection;
    } else {
      return 'Update RSVP Status';
    }
  };

  render() {
    const { handleClick, mealQuestion, events, gdsUiState } = this.props;
    const { mealBulkSelection } = gdsUiState;
    const { rsvpMenuState, mealMenuState } = this.state;

    return (
      <div className={styles.dropdownContainer}>
        <SelectDropdown
          label={this.getRsvpLabel()}
          setMenuState={this.setMenuState.bind('null', 'rsvpMenuState')}
          menuOpen={rsvpMenuState}
        >
          <div className={styles.dropdownContents}>
            {gdsUiState.selectedEvent ? (
              <RsvpDropdown
                rsvpFilter={handleClick.bind(null, 'rsvp')}
                currentSelection={'attending'}
                setMenuState={this.setMenuState.bind('null', 'rsvpMenuState')}
              />
            ) : (
              <OverviewRsvpDropdownContents
                type="selection"
                setMenuState={this.setMenuState.bind('null', 'rsvpMenuState')}
                rsvpFilter={handleClick.bind(null, 'overview')}
                events={events}
                gdsUiState={gdsUiState}
              />
            )}
          </div>
        </SelectDropdown>
        {get(mealQuestion, ['options', 'length']) ? (
          <SelectDropdown
            label={mealBulkSelection ? mealBulkSelection.text || 'No Reply' : 'Update Meal Choice'}
            setMenuState={this.setMenuState.bind('null', 'mealMenuState')}
            menuOpen={mealMenuState}
          >
            <div className={styles.dropdownContents}>
              <MealDropdown
                showCheckmark
                borders={true}
                meals={mealQuestion.options}
                onClick={handleClick.bind(null, 'meal')}
                setMenuState={this.setMenuState.bind('null', 'mealMenuState')}
              />
            </div>
          </SelectDropdown>
        ) : null}
      </div>
    );
  }
}

export default SelectedGuestsDropdowns;
